import React, { useEffect, useRef, useState } from 'react';
import ReviewCard from "../Utils/Cards/review-card-component";
import './review-list-styles.css';

const ReviewList = ({ reviews }) => {
    const scrollContainerRef = useRef(null);
    const [isHovering, setIsHovering] = useState(false);
    const [scrollDirection, setScrollDirection] = useState(1); // 1 for right, -1 for left

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        // Smooth continuous scroll function
        const smoothScroll = () => {
            if (!isHovering) {
                container.scrollLeft += scrollDirection; // Increment or decrement based on direction

                // Reverse direction at ends
                if (container.scrollLeft >= container.scrollWidth - container.clientWidth ||
                    container.scrollLeft <= 0) {
                    setScrollDirection(-scrollDirection);
                }
            }
        };

        // Set up interval for continuous scrolling
        const interval = setInterval(smoothScroll, 20); // Adjust time for speed

        // Event listeners for hover state
        const handleMouseEnter = () => setIsHovering(true);
        const handleMouseLeave = () => setIsHovering(false);
        container.addEventListener('mouseenter', handleMouseEnter);
        container.addEventListener('mouseleave', handleMouseLeave);

        // Clean-up function
        return () => {
            clearInterval(interval);
            container.removeEventListener('mouseenter', handleMouseEnter);
            container.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [isHovering, scrollDirection]);

    return (
        <div ref={scrollContainerRef} className='flex overflow-auto w-screen '>
            {reviews.map((review, index) => (
                <div key={index} className="review-card-wrapper">
                    <ReviewCard
                        name={review.name}
                        joinDate={review.joinDate}
                        reviewDate={review.reviewDate}
                        reviewText={review.reviewText}
                        helpfulCount={review.helpfulCount}
                        shortText={review.shortText}
                    />
                </div>
            ))}
        </div>
    );
};

export default ReviewList;
